export default {
	consultantTitle:'Select a consultant',
	consultantDescription:'To book a consultation, first select the consultant you want.',
	serviceTitle:'Service selection',
	serviceDescription:'Choose one of the services offered by the consultant of your choice.',
	dateTitle:'Date selection',
	dateDescription:'What day and time do you need counseling? Choose it and book your time.',
	formTitle:'Personal profile',
	formDescription:'Once you have completed the details, finalize your booking time and confirm payment.',
	paymentButton:'Confirm information and payment',

	profile:{
		consultant:'Consultant: ',
		service:'Service: ',
		dateOfConsultation:'date of consultation: ',
		consultationHours:'consultation hours: '
	},
	am:'AM',
	pm:'PM',

	dateError:'Not available on the consultant\'s chosen date',

	successPayment:'Your payment was successful and time was booked with the following details.',
	failedPaymentButton:'Try again to pay'

}
